<template>
	<popup v-model="selfDisplay" title="设置代理" @confirmClick="handleConfirmClick">
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">总计卡数</span>
				<el-input :value="`${ ids.length }张`" disabled></el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>代理名称</span>
				<el-select filterable v-model="agent" placeholder="请选择" style="width: 100%;">
					<el-option v-for="v in allAgentlist" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="agentTip"><i
						class="b_icon"></i>请选择机构</template></div>

			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>卡片状态</span>
				<el-select v-model="state" placeholder="请选择" style="width: 100%;">
					<el-option v-for="v in cardState" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="stateTip"><i
						class="b_icon"></i>请选择卡片状态</template></div>
		</div>
	</popup>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	import Api from '../../../../../../api/index.js';

	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			ids: {
				type: Array,
				default: () => []
			}
		},
		mounted() {
			this.display && (this.selfDisplay = true);
			this.findAllAgent();

		},
		data() {
			return {
				selfDisplay: false,
				loading: false,

				agent: '',
				state: '',
				agentTip: false,
				stateTip: false,
				allAgentlist: [], //代理
			}
		},
		computed: {
			...mapState([
				'allAgent',
				'cardState'
			])
		},
		methods: {
			// 点击确定
			handleConfirmClick() {
				const that = this;
				let name = that.Dlist(that.agent)
				if (!that.agent) {
					that.agentTip = true;
					return false;
				} else {
					that.agentTip = false;
				}
				if (!that.state.toString()) {
					that.stateTip = true;
					return false;
				} else {
					that.stateTip = false;
				}
				that.loading = true;
				let requestData = {
					cardIds: that.ids,
					cardSmallType: that.state,
					enterpriseName: name,
					newEnterpriseId: that.agent,
				};
				Api.setAgent(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},




			// 获取代理商
			findAllAgent() {
				const that = this;
				// 0超级管理员 1是代理  2是机构
				let requestData = {
					category: 1
				}
				Api.findAllAgent(requestData).then((res) => {
					if (res.data.success) {
						let list = [];
						res.data.data.forEach((v) => {
							list.push({
								id: v.enterpriseId,
								name: v.enterpriseName
							});
						});

						that.allAgentlist = list

						// that.setAllAgent(list);
						// Loading.close();
						// that.$router.replace({
						// 	path: '/index'
						// });
					} else {
						// Loading.close();
						that.$message.error(res.data.message);
					}
				}, (e) => {
					// Loading.close();
					that.$message.error(e.message);
				});
			},


			Dlist(newEnterpriseId) {
				let name = '';
				this.allAgentlist.forEach(v => {
					if (v.id == newEnterpriseId) {
						name = v.name
					}
				})
				return name


			}


		},



		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit('changeDisplay', newVal);
				if (!newVal) {
					this.loading = false;
					this.agent = '';
					this.state = '';
					this.agentTip = false;
					this.stateTip = false;
				}
			}
		}
	}
</script>

<style>
</style>